import { css } from 'styled-components';
import { themeMode } from '@landr/maestro';

const CoachmarkRoot = css({});

const CoachmarkVariant = {
    base: themeMode({
        light: css({
            color: '#142739', // neutral.900',
            backgroundColor: '#f9fafb', // 'neutral.50',
        }),
        dark: css({
            color: '#f9fafb', // 'neutral.50',
            backgroundColor: '#142739', // neutral.900',
        }),
    }),
    accent: themeMode({
        light: css({
            backgroundColor: '#0c4bce', // secondary.500',
        }),
        dark: css({
            backgroundColor: '#0c4bce', // secondary.500',
        }),
    }),
};

const styles = {
    root: CoachmarkRoot,
    variant: CoachmarkVariant,
};

export default styles;
